(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-about-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(sec) {
      if (sec.dataset.b2bReady) return;
      sec.dataset.b2bReady = '1';
      if (window.Shopify && window.Shopify.designMode) return;                                   // easy to edit in the theme editor
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // visitors who want less motion
      sec.classList.add('is-ready');

      var rows = [].slice.call(sec.querySelectorAll('.b2b-story__row'));
      var tl = sec.querySelector('.b2b-story__tl'), fill = sec.querySelector('.b2b-story__fill');
      var photos = [].slice.call(sec.querySelectorAll('.b2b-story__img, .b2b-story__ph'));
      var bubbles = [].slice.call(sec.querySelectorAll('.b2b-story__bubble'));
      var parallax = sec.dataset.parallax === 'true';

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
        rows.forEach(function (r) { io.observe(r); });
      } else { rows.forEach(function (r) { r.classList.add('is-in'); }); }

      var ticking = false;
      function update() {
        ticking = false;
        var vh = window.innerHeight, mid = vh / 2;
        if (tl && fill) {
          var tr = tl.getBoundingClientRect();
          fill.style.transform = 'scaleY(' + Math.max(0, Math.min(1, (mid - tr.top) / tr.height)).toFixed(3) + ')';
        }
        rows.forEach(function (row) {
          var r = row.getBoundingClientRect();
          row.classList.toggle('is-reached', r.top + r.height * 0.3 < mid);
          row.classList.toggle('is-active', r.top < mid && r.bottom > mid);
        });
        if (parallax) {
          photos.forEach(function (el) {
            var r = el.parentElement.getBoundingClientRect();
            el.style.setProperty('--py', Math.max(-26, Math.min(26, -(r.top + r.height / 2 - mid) * 0.07)).toFixed(1) + 'px');
          });
          var sr = sec.getBoundingClientRect(), c = sr.top + sr.height / 2 - mid;
          bubbles.forEach(function (b) { b.style.transform = 'translate3d(0,' + (-c * (parseFloat(b.dataset.speed) || 0.1)).toFixed(1) + 'px,0)'; });
        }
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }
    function init() { document.querySelectorAll('.b2b-story').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-catalog-selectors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeAll(except) {
      document.querySelectorAll('.b2b-sel__tile[aria-expanded="true"]').forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var m = document.getElementById(t.getAttribute('aria-controls'));
        if (m) m.hidden = true;
      });
    }
    document.addEventListener('click', function (e) {
      var tile = e.target.closest('.b2b-sel__tile[aria-controls]');
      if (tile) {
        var menu = document.getElementById(tile.getAttribute('aria-controls'));
        var open = tile.getAttribute('aria-expanded') === 'true';
        closeAll(open ? null : tile);
        tile.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (menu) menu.hidden = open;
        return;
      }
      if (!e.target.closest('.b2b-sel__menu')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });

    /* the small floating bar */
    function setupDock() {
      var dock = document.querySelector('.b2b-sel__dock');
      if (!dock || dock.dataset.b2bReady) return;
      dock.dataset.b2bReady = '1';
      var grid = document.querySelector('.b2b-sel__grid'), fly = dock.querySelector('.b2b-sel__flyout');
      var min = parseInt(dock.dataset.min, 10) || 1200, past = false;
      function closeFly() {
        fly.hidden = true;
        dock.querySelectorAll('.b2b-sel__dbtn[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
      function sync() {
        var on = past && window.innerWidth >= min;
        dock.classList.toggle('is-on', on);
        if (!on) closeFly();
      }
      if (grid && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          past = !e.isIntersecting && e.boundingClientRect.bottom < 0;      // the big tiles are above the screen
          sync();
        }).observe(grid);
      }
      window.addEventListener('resize', sync);
      dock.addEventListener('click', function (e) {
        var b = e.target.closest('.b2b-sel__dbtn');
        if (!b || b.disabled) return;
        var wasOpen = b.getAttribute('aria-expanded') === 'true';
        closeFly();
        if (wasOpen) return;
        var src = document.getElementById(b.dataset.menu);
        if (!src) return;
        fly.innerHTML = src.innerHTML;
        fly.hidden = false;
        fly.style.top = Math.max(b.offsetTop - 4, 0) + 'px';
        var r = fly.getBoundingClientRect(), over = r.bottom - (window.innerHeight - 12);
        if (over > 0) fly.style.top = Math.max(b.offsetTop - 4 - over, -dock.offsetTop + 8) + 'px';
        b.setAttribute('aria-expanded', 'true');
      });
      document.addEventListener('click', function (e) { if (!e.target.closest('.b2b-sel__dock')) closeFly(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFly(); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupDock); else setupDock();
    document.addEventListener('shopify:section:load', setupDock);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-category-tiles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('pointerover', function (e) {
    var t = e.target.closest && e.target.closest('.b2b-tiles__track');
    if (!t || t.dataset.b2bWarm) return;
    t.dataset.b2bWarm = '1';
    t.querySelectorAll('img.b2b-tile__img--hover').forEach(function (i) { i.loading = 'eager'; });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.b2b-tiles__arrow[data-dir]');
    if (!b) return;
    var track = b.closest('.b2b-tiles').querySelector('.b2b-tiles__track');
    track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  // Tiles: dragging with the mouse (touch screens scroll by themselves), and an optional slow automatic movement to the left.
  // The movement pauses on hover, touch and focus, has a pause button, and is off when the visitor's device asks for less motion.
  (function () {
    function cloneRow(originals) {
      return originals.map(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        return c;
      });
    }

    function start(section) {
      if (section.dataset.b2bReady) return;
      if (window.Shopify && window.Shopify.designMode) return;
      section.dataset.b2bReady = '1';
      var track = section.querySelector('.b2b-tiles__track');
      var originals = Array.prototype.slice.call(track.children);
      if (!originals.length) return;
      var auto = section.dataset.auto === 'true' && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

      // an endless row: a copy before, and enough copies after, the original tiles
      var L = 0;
      function measure() { L = track.children[originals.length].offsetLeft - track.children[0].offsetLeft; }
      if (auto) {
        cloneRow(originals).reverse().forEach(function (c) { track.insertBefore(c, track.firstChild); });
        cloneRow(originals).forEach(function (c) { track.appendChild(c); });
        measure();
        var more = L > 0 ? Math.ceil(track.clientWidth / L) : 0;
        for (var i = 0; i < more; i++) cloneRow(originals).forEach(function (c) { track.appendChild(c); });
        measure();
        section.classList.add('b2b-tiles--auto');
        track.scrollLeft = L;
        window.addEventListener('resize', function () { var before = L; measure(); if (before > 0 && L > 0) track.scrollLeft = track.scrollLeft * L / before; });
      }

      // keeps the position inside one copy of the row, so the row never ends. Returns how far it moved the row.
      function wrap() {
        if (!auto || L <= 0) return 0;
        var x = track.scrollLeft, d = 0;
        if (x >= 2 * L) d = -L; else if (x < L) d = L;
        if (d) track.scrollLeft = x + d;
        return d;
      }

      var held = false, userPaused = false, visible = true, last = null, acc = 0, touchTimer;
      var dragging = false, moved = 0, startX = 0, startLeft = 0;

      // dragging with the mouse
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        dragging = true; moved = 0; startX = e.clientX; startLeft = track.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > moved) moved = Math.abs(dx);
        if (moved <= 5) return;                      // still a click: the tiles stay clickable until the mouse has really moved
        track.classList.add('is-dragging');
        track.scrollLeft = startLeft - dx;
        startLeft += wrap();
      });
      function endDrag() { if (!dragging) return; dragging = false; track.classList.remove('is-dragging'); }
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      // a drag must not open the tile it ends on
      track.addEventListener('click', function (e) { if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);

      if (!auto) return;

      var pause = section.querySelector('.b2b-tiles__pause');
      if (pause) pause.addEventListener('click', function () {
        userPaused = !userPaused;
        pause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
        pause.innerHTML = userPaused ? '&#9654;' : '&#10074;&#10074;';
        pause.setAttribute('aria-label', pause.getAttribute(userPaused ? 'data-label-start' : 'data-label-pause') || '');
      });
      track.addEventListener('mouseenter', function () { held = true; });
      track.addEventListener('mouseleave', function () { held = false; });
      track.addEventListener('focusin', function () { held = true; });
      track.addEventListener('focusout', function () { held = false; });
      track.addEventListener('touchstart', function () { held = true; clearTimeout(touchTimer); }, { passive: true });
      track.addEventListener('touchend', function () { touchTimer = setTimeout(function () { held = false; }, 3000); }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(track);

      var speed = parseFloat(section.dataset.speed) || 25; // pixels per second
      function step(ts) {
        if (last === null) last = ts;
        var dt = ts - last; last = ts;
        if (!held && !userPaused && !dragging && visible && !document.hidden) {
          acc += speed * dt / 1000;
          var whole = Math.floor(acc);
          if (whole >= 1) { track.scrollLeft += whole; acc -= whole; }
        }
        wrap();
        requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    function init() { document.querySelectorAll('.b2b-tiles').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-header-image"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(el) {
      var effect = el.dataset.effect, fadeout = el.dataset.fadeout === 'true';
      if (el.dataset.b2bReady || (effect !== 'parallax' && effect !== 'zoom' && !fadeout)) return;
      el.dataset.b2bReady = '1';
      if (window.Shopify && window.Shopify.designMode) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var media = el.querySelector('.b2b-hi__media'), img = el.querySelector('.b2b-hi__img');
      if (!media || !img) return;
      var f = parseFloat(el.dataset.factor) || 0.3, z = parseFloat(el.dataset.zoom) || 0.15, base = parseFloat(el.dataset.scale) || 1;
      var dist = Math.max(parseFloat(el.dataset.fadeDistance) || 500, 50);
      var ticking = false;
      function update() {
        ticking = false;
        var h = media.offsetHeight, y = Math.max(window.scrollY, 0);
        if (effect === 'parallax') {
          img.style.setProperty('--hi-py', Math.min(y * f, h * f).toFixed(1) + 'px');
        } else if (effect === 'zoom') {
          var p = Math.min(y / (h || 1), 1);
          img.style.setProperty('--hi-zs', (base * (1 + p * z)).toFixed(4));
        }
        if (fadeout) media.style.setProperty('--hi-o', (1 - Math.min(y / dist, 1)).toFixed(3));
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
    function init() { document.querySelectorAll('.b2b-hi').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-inspiration"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var OFFSET_K = [0, -0.5, 0.3, -1, 0.6];                       // how each column drifts, relative to the strongest

    function start(sec) {
      if (sec.dataset.b2bReady) return;
      sec.dataset.b2bReady = '1';
      var grid = sec.querySelector('.b2b-insp__grid');
      var items = [].slice.call(grid.querySelectorAll('.b2b-insp__item'));
      var desktopCols = parseInt(sec.dataset.cols, 10) || 4;
      var backdrop = sec.querySelector('.b2b-insp__backdrop');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var editing = !!(window.Shopify && window.Shopify.designMode);
      var cols = [], n = 0;

      /* arrange the pictures in columns, in reading order: 1, 2, 3, 4, then the next row, and so on */
      function layout() {
        var want = window.innerWidth < 750 ? 2 : desktopCols;
        if (want === n) return;
        n = want; closeAll();
        grid.style.setProperty('--n', n);
        grid.textContent = '';
        cols = [];
        for (var i = 0; i < n; i++) { var c = document.createElement('div'); c.className = 'b2b-insp__col'; c.dataset.k = i; grid.appendChild(c); cols.push(c); }
        items.forEach(function (it, i) { cols[i % n].appendChild(it); });
        update();
      }

      /* the speech bubble */
      function closeAll() {
        sec.querySelectorAll('.b2b-insp__item.is-open').forEach(function (it) {
          it.classList.remove('is-open');
          it.querySelector('.b2b-insp__bubble').hidden = true;
          it.querySelector('.b2b-insp__tile').setAttribute('aria-expanded', 'false');
        });
        backdrop.hidden = true;
      }
      function open(it) {
        var wasOpen = it.classList.contains('is-open');
        closeAll();
        if (wasOpen) return;
        var tile = it.querySelector('.b2b-insp__tile'), bubble = it.querySelector('.b2b-insp__bubble');
        var r = tile.getBoundingClientRect(), w = 21 * 16 + 16;
        it.dataset.side = (r.right + w > window.innerWidth - 8) ? 'left' : 'right';
        it.classList.add('is-open'); bubble.hidden = false; bubble.style.top = '0px'; bubble.style.removeProperty('--arrow');
        tile.setAttribute('aria-expanded', 'true');
        if (window.innerWidth < 750) { backdrop.hidden = false; }
        else {                                                    // keep the bubble on the screen
          var b = bubble.getBoundingClientRect(), over = b.bottom - (window.innerHeight - 12);
          if (over > 0) { var shift = Math.min(over, Math.max(r.height - 70, 0)); bubble.style.top = (-shift) + 'px'; bubble.style.setProperty('--arrow', (2 * 16 + shift) + 'px'); }
        }
        bubble.querySelector('.b2b-insp__close').focus({ preventScroll: true });
      }
      sec.addEventListener('click', function (e) {
        var close = e.target.closest('.b2b-insp__close');
        if (close) { var it0 = close.closest('.b2b-insp__item'); var t = it0.querySelector('.b2b-insp__tile'); closeAll(); t.focus({ preventScroll: true }); return; }
        var tile = e.target.closest('.b2b-insp__tile');
        if (tile) { open(tile.closest('.b2b-insp__item')); e.stopPropagation(); }
      });
      document.addEventListener('click', function (e) { if (!e.target.closest('.b2b-insp__item')) closeAll(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

      /* drifting columns, and the entrance of the pictures */
      var ticking = false;
      function update() {
        ticking = false;
        if (sec.dataset.drift !== 'true' || calm || editing || n < 3) { cols.forEach(function (c) { c.style.transform = ''; }); return; }
        var strength = (parseFloat(sec.dataset.driftStrength) || 100) / 100;
        var r = grid.getBoundingClientRect(), vh = window.innerHeight;
        var p = Math.min(Math.max(vh - r.top, 0), r.height + vh) / (r.height + vh);   // 0 when the gallery comes in, 1 when it has left
        cols.forEach(function (c, i) { c.style.transform = 'translate3d(0,' + (p * 140 * strength * (OFFSET_K[i % 5])).toFixed(1) + 'px,0)'; });
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { layout(); onScroll(); });

      layout();
      if (!calm && !editing && 'IntersectionObserver' in window) {
        sec.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
        }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });
        items.forEach(function (it) { io.observe(it); });
      }
      update();
    }
    function init() { document.querySelectorAll('.b2b-insp').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-quality-pillars"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(sec) {
      if (sec.dataset.b2bReady) return;
      sec.dataset.b2bReady = '1';
      if (window.Shopify && window.Shopify.designMode) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      sec.classList.add('is-ready');
      var cards = [].slice.call(sec.querySelectorAll('.b2b-q__card'));
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = cards.indexOf(e.target);
          e.target.style.transitionDelay = ((i % 2) * 0.12) + 's';
          e.target.classList.add('is-in');
          io.unobserve(e.target);
          setTimeout(function () { e.target.style.transitionDelay = ''; }, 900);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    }
    function init() { document.querySelectorAll('.b2b-q').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(hero) {
      if (hero.dataset.b2bReady || hero.dataset.motion !== 'parallax') return;
      hero.dataset.b2bReady = '1';
      if (window.Shopify && window.Shopify.designMode) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var strength = Math.min(Math.max(parseFloat(hero.dataset.parallaxStrength) || 50, 10), 100);
      var ratio = 0.02 + (strength / 100) * 0.14;           // how far the picture may move, as a share of the hero height
      hero.style.setProperty('--hero-pz', (1 + 2 * ratio).toFixed(3));
      var ticking = false;
      function update() {
        ticking = false;
        var r = hero.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < -50 || r.top > vh + 50) return;
        var p = Math.min(Math.max((vh - r.top) / (vh + r.height), 0), 1);
        hero.style.setProperty('--hero-py', ((p - 0.5) * 2 * ratio * r.height).toFixed(1) + 'px');
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function init() { document.querySelectorAll('.hero[data-motion]').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
